var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-container"},[_c('div',{staticClass:"table"},[_c('div',{staticClass:"loading card-title shorter-s"}),_vm._l((_vm.rows),function(row){return _c('div',{key:'ks-skeleton-table-row-'+row,staticClass:"loading table-content"})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }